module.exports = __webpack_public_path__ + "static/img/howtorent_header.705e0cb7.jpg";